import script from "./add-machine.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-machine.vue?vue&type=script&setup=true&lang=ts"

import "./add-machine.vue?vue&type=style&index=0&id=2f0a6f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0a6f4a"]])

export default __exports__